export class Utils {
	public static phoneMaxSize = 689;
	public static desktopFlexMinSize = 1024;
	public static desktopStaticMinWidth = 1240;
	public static tabletMinSize = Utils.phoneMaxSize + 1;
	public static tabletMaxSize = Utils.desktopFlexMinSize - 1;
	public static desktopFlexMaxSize = Utils.desktopStaticMinWidth - 1;
	public static menuHeight = 70 + 45;

	public static monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
  		"Juli", "August", "September", "Oktober", "November", "Dezember"
	];
	public static monthNamesShort = ["Jan", "Febr", "März", "Apr", "Mai", "Juni",
  		"Juli", "Aug", "Sept", "Okt", "Nov", "Dez"
	];

	public static isClassInAncestors(element: HTMLElement|null, className: string):boolean{
		if(element == null){
			return false;
		}
		if(element.classList.contains(className)){
			return true;
		}
		return Utils.isClassInAncestors(element.parentElement,className);
	}
	
	public static checkIfViewEndIsVisible(element:HTMLElement){
    	var offset = element.offsetTop - window.pageYOffset;

    	if(offset > window.innerHeight){
    	    return false;
    	}
   		return true;
	}

	public static insertAsFirstChildElement(container:HTMLElement,toAdd:HTMLElement){
		    container.insertBefore(toAdd, container.firstChild);
	}

	public static isPhone():boolean{
		if(window.innerWidth <= Utils.phoneMaxSize){
			return true;
		}else{
			return false;
		}
	}
}